import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { useFiltersStore } from '../../../store/filtersStore';

interface StatusCircleFilterProps {
  status: number | 'others' | string | 'postulado' | 'adjudicado' | 'no-leidas';
  color: string;
  tooltip: string;
  label: string;
  filterType?: 'status' | 'postulado' | 'adjudicado' | 'no-leidas';
}

const StatusCircleFilter: React.FC<StatusCircleFilterProps> = ({ status, color, tooltip, label, filterType = 'status' }) => {
  const { activeStatusFilters, toggleStatusFilter, postuladoFilter, adjudicadoFilter, noLeidasFilter, setPostuladoFilter, setAdjudicadoFilter, setNoLeidasFilter } = useFiltersStore();
  
  const isActive = filterType === 'status' 
    ? activeStatusFilters.includes(status)
    : filterType === 'postulado' 
      ? postuladoFilter === true
      : filterType === 'adjudicado'
        ? adjudicadoFilter === true
        : noLeidasFilter === true;

  const handleClick = () => {
    if (filterType === 'status') {
      toggleStatusFilter(status);
    } else if (filterType === 'postulado') {
      setPostuladoFilter(postuladoFilter === true ? null : true);
    } else if (filterType === 'adjudicado') {
      setAdjudicadoFilter(adjudicadoFilter === true ? null : true);
    } else if (filterType === 'no-leidas') {
      setNoLeidasFilter(noLeidasFilter === true ? null : true);
    }
  };

  const getDisplayColor = () => {
    return color;
  };

  const getDisplayLabel = () => {
    if (filterType === 'postulado') {
      return 'Postulado';
    }
    if (filterType === 'adjudicado') {
      return 'Adjudicado';
    }
    if (filterType === 'no-leidas') {
      return 'No Leídas';
    }
    return label;
  };

  const getDisplayTooltip = () => {
    if (filterType === 'postulado') {
      return postuladoFilter === true ? 'Quitar filtro de postulación' : 'Filtrar por postuladas';
    }
    if (filterType === 'adjudicado') {
      return adjudicadoFilter === true ? 'Quitar filtro de adjudicación' : 'Filtrar por adjudicadas';
    }
    if (filterType === 'no-leidas') {
      return noLeidasFilter === true ? 'Mostrar todas las licitaciones' : 'Filtrar por no leídas';
    }
    return tooltip;
  };

  const isActiveFilter = filterType === 'status' 
    ? isActive
    : filterType === 'postulado' 
      ? postuladoFilter !== null
      : filterType === 'adjudicado'
        ? adjudicadoFilter !== null
        : noLeidasFilter !== null;

  return (
    <Tooltip title={getDisplayTooltip()} arrow>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 0.5,
          cursor: 'pointer',
          padding: '4px 8px',
          backgroundColor: isActiveFilter ? '#f0f0f0' : 'white',
          border: '1px solid #E6E6E6',
          borderRadius: 1,
          '&:hover': {
            backgroundColor: '#f5f5f5',
          },
        }}
        onClick={handleClick}
      >
        {getDisplayColor() !== 'transparent' && (
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: getDisplayColor(),
            }}
          />
        )}
        <Typography
          sx={{
            fontSize: '12px',
            color: '#666',
            fontWeight: isActiveFilter ? 600 : 400,
            userSelect: 'none'
          }}
        >
          {getDisplayLabel()}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default StatusCircleFilter; 